import { UseGqlMutationCallbacks, useMutationWithInvalidation } from '@alice-financial/api'
import { useMutationNotifier } from '../../../notifications/useMutationNotifier'
import { useOrgDashboardQuery } from '../queries/orgDashboard_gen'
import {
  UpdateOrganizationMutation,
  UpdateOrganizationMutationVariables,
  useUpdateOrganizationMutation,
} from './updateOrganization_gen'

type UseUpdateOrganizationOptions = UseGqlMutationCallbacks<
  UpdateOrganizationMutation,
  UpdateOrganizationMutationVariables
>

export const useUpdateOrganization = (mutationOptions?: UseUpdateOrganizationOptions) => {
  const { mutateAsync: updateOrganization } = useUpdateOrganizationMutation()
  const optionsWithNotification = useMutationNotifier({}, mutationOptions)

  return useMutationWithInvalidation(updateOrganization, optionsWithNotification, [
    (_data: unknown, variables: UpdateOrganizationMutationVariables) =>
      useOrgDashboardQuery.getKey({ orgId: variables.input.orgId }),
  ])
}
